import { AlertTriangle, Shield, X, Download, CheckCircle } from 'lucide-react';
import React, { useEffect } from 'react';

const NotificationPopup = ({ notification, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 10000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const getIconAndColor = () => {
    switch (notification.type) {
      case 'warning':
        return { Icon: AlertTriangle, color: 'text-yellow-400' };
      case 'success':
        return { Icon: CheckCircle, color: 'text-green-400' };
      case 'download':
        return { Icon: Download, color: 'text-blue-400' };
      default:
        return { Icon: Shield, color: 'text-blue-400' };
    }
  };

  const { Icon, color: iconColor } = getIconAndColor();

  return (
    <div className="w-80 bg-gray-800/90 text-white rounded-lg shadow-2xl p-4 border border-white/20 backdrop-blur-md animate-fade-in-up">
      <div className="flex items-start">
        <Icon size={24} className={`${iconColor} mr-3 flex-shrink-0 mt-1`} />
        <div className="flex-1">
          <h4 className="font-bold">{notification.title}</h4>
          <p className="text-sm text-gray-300">{notification.message}</p>
        </div>
        <button onClick={onClose} className="ml-2 p-1 rounded-full hover:bg-white/20">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default NotificationPopup;

